module.exports = __webpack_public_path__ + "img/bg.2313550e.png";